import type { PImage } from '../../engine/aliases'
import { phaserUtil } from '../../engine/phaserUtil-sidecar'
import type { IEntity } from '../../entities/entitiesUtils'
import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import type { IIJ } from '../../lib/distanceUtil'
import { l } from '../../lib/imports'
import { mathUtils } from '../../lib/mathUtils-sidecar'
import { common } from '../../main/common-sidecar'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { voyageColors } from './voyageColors-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'

export interface IVoyageIndicator extends IEntity {
  images: PImage[]
  w: number
  h: number
  x: number
  y: number
}

const _offsets = [
  [0, -1],
  [1, 0],
  [0, 1],
  [-1, 0],
]

const objs: IVoyageIndicator[] = []
export function getAll() {
  return objs
}

export function create(): IVoyageIndicator {
  let images: PImage[] = []
  for (let i = 0; i < 4; i++) {
    let image = spritesUtil.createImage(
      voyageLayers.getLayers().shipAbove,
      sprites.voyTileIndicators[i],
    )
    images.push(image)
    image.tint = voyageColors.yellow
  }

  let obj: IVoyageIndicator = {
    id: -1,
    idLoaded: -1,
    isDead: false,
    eType: 'voy-misc',
    images,
    w: 32,
    h: 32,
    x: 0,
    y: 0,
  }
  objs.push(obj)

  return obj
}

export function moveToIJ(obj: IVoyageIndicator, iij: IIJ) {
  // obj.i = iij.i
  // obj.j = iij.j
  let t = voyageTilemap.getSafe(iij.i, iij.j)
  if (t) {
    moveToXY(obj, t.x, t.y)
  }
}

export function moveToXY(
  obj: IVoyageIndicator,
  x: number,
  y: number,
  w = 32,
  h = 32,
) {
  obj.x = x
  obj.y = y
  obj.w = w
  obj.h = h
  l.forEach(obj.images, (c, cIdx) => {
    let os = _offsets[cIdx]
    c.x = x + (os[0] * w) / 2
    c.y = y + (os[1] * h) / 2
  })
}

export function kill(obj: IVoyageIndicator) {
  obj.isDead = true
}
export function killAll() {
  l.forEach(objs, (c) => {
    kill(c)
  })
  removeDead()
}

export function updateAll() {
  l.forEach(objs, (c) => {
    update(c)
  })
  removeDead()
}
export function removeDead() {
  entitiesUtils.removeDead(objs, (c) => {
    phaserUtil.destroyAllImages(c.images)
  })
}
function update(obj: IVoyageIndicator) {
  let ds = common.getUpdateDeltaScaled()
  let et = common.getElapsedTime()

  let scale = mathUtils.sineLike(et, 2, 1, 2)
  let w = obj.w * scale
  let h = obj.h * scale

  l.forEach(obj.images, (c, cIdx) => {
    let os = _offsets[cIdx]
    c.x = obj.x + (os[0] * w) / 2
    c.y = obj.y + (os[1] * h) / 2
  })
}
